export default "__VITE_ASSET__BGz99vc$__"